import Vue from 'vue';
import Router from 'vue-router';
import axios from '../api/axiosFun';
import talentRoutes from './talent';
import natvipRoutes from './natvip';
import childOneRoutes from './childOne';
import { getBaseUrl, AUTH_URL, VISIT_URL, GET_USERINFO_By_OPENID_URL, AUTH_APPID } from '../api/config';
import { Toast } from 'vant';
import { applyRemPolicyForRoute } from '@/utils/remManager';

Vue.use(Toast);
const disinfect = r => require.ensure([], () => r(require('../views/disinfect.vue')), 'disinfect');
const notelink = r => require.ensure([], () => r(require('../views/notelink.vue')), 'notelink');
const coupons3000 = r => require.ensure([], () => r(require('../views/coupons3000.vue')), 'coupons3000');
const coupons4000 = r => require.ensure([], () => r(require('../views/coupons4000.vue')), 'coupons4000');
const probioticsClock = r => require.ensure([], () => r(require('../views/probioticsClock.vue')), 'probioticsClock');
const probioticsClockFst = r =>
    require.ensure([], () => r(require('../views/probioticsClockFst.vue')), 'probioticsClockFst');
const probioticsClockSec = r =>
    require.ensure([], () => r(require('../views/probioticsClockSec.vue')), 'probioticsClockSec');
const probioticsClockThr = r =>
    require.ensure([], () => r(require('../views/probioticsClockThr.vue')), 'probioticsClockThr');
const probioticsClockFou = r =>
    require.ensure([], () => r(require('../views/probioticsClockFou.vue')), 'probioticsClockFou');
const probioticsClockFif = r =>
    require.ensure([], () => r(require('../views/probioticsClockFif.vue')), 'probioticsClockFif');
const probioticsClockSix = r =>
    require.ensure([], () => r(require('../views/probioticsClockSix.vue')), 'probioticsClockSix');
const advert = r => require.ensure([], () => r(require('../views/advert.vue')), 'advert');
const anniversary = r => require.ensure([], () => r(require('../views/anniversary.vue')), 'anniversary');
const highValue = r => require.ensure([], () => r(require('../views/highValue.vue')), 'highValue');
const wednesday = r => require.ensure([], () => r(require('../views/wednesday.vue')), 'wednesday');
const scheme = r => require.ensure([], () => r(require('../views/scheme.vue')), 'scheme');
const schemeToSub = r => require.ensure([], () => r(require('../views/schemeToSub.vue')), 'schemeToSub');
const schemeMine = r => require.ensure([], () => r(require('../views/schemeMine.vue')), 'schemeMine');
const policy = r => require.ensure([], () => r(require('../views/policy.vue')), 'policy');
const buyShow = r => require.ensure([], () => r(require('../views/buyShow.vue')), 'buyShow');
const pageTo = r => require.ensure([], () => r(require('../views/pageTo.vue')), 'pageTo');
const toLive = r => require.ensure([], () => r(require('../views/toLive.vue')), 'toLive');
const forVvip = r => require.ensure([], () => r(require('../views/forVvip.vue')), 'forVvip');
const logoutFile = r => require.ensure([], () => r(require('../views/logoutFile.vue')), 'logoutFile');
const personalInfo = r => require.ensure([], () => r(require('../views/personalInfo.vue')), 'personalInfo');
const thirdPartyInfo = r => require.ensure([], () => r(require('../views/thirdPartyInfo.vue')), 'thirdPartyInfo');
const userAgreement = r => require.ensure([], () => r(require('../views/userAgreement.vue')), 'userAgreement');
const summary = r => require.ensure([], () => r(require('../views/summary.vue')), 'summary');
const dataSearch = r => require.ensure([], () => r(require('../views/dataSearch.vue')), 'dataSearch');
const publicAct = r => require.ensure([], () => r(require('../views/publicAct.vue')), 'publicAct');
const goodsDetail = r => require.ensure([], () => r(require('../views/goodsDetail.vue')), 'goodsDetail');
const sphScheme = r => require.ensure([], () => r(require('../views/sphScheme.vue')), 'sphScheme');
const schemeLz = r => require.ensure([], () => r(require('../views/schemeLz.vue')), 'schemeLz');
// 贝黎诗隐私相关页面 palaispa
const palaispaPolicy = r => require.ensure([], () => r(require('../views/plsPolicy.vue')), 'palaispaPolicy');
const palaispaUserAgreement = r =>
    require.ensure([], () => r(require('../views/plsUserAgreement.vue')), 'palaispaUserAgreement');
const palaispaSummary = r => require.ensure([], () => r(require('../views/plsSummary.vue')), 'palaispaSummary');
const palaispaPersonalInfo = r =>
    require.ensure([], () => r(require('../views/plsPersonalInfo.vue')), 'palaispaPersonalInfo');
const palaispaThirdPartyInfo = r =>
    require.ensure([], () => r(require('../views/plsThirdPartyInfo.vue')), 'palaispaThirdPartyInfo');
const palaispaLogoutFile = r =>
    require.ensure([], () => r(require('../views/plsLogoutFile.vue')), 'palaispaLogoutFile');
const christmasSales = r => require.ensure([], () => r(require('../views/christmasSales.vue')), 'christmasSales');
const activityTemplate = r => require.ensure([], () => r(require('../views/activityTemplate.vue')), 'activityTemplate');
const activityTemplateNew = r =>
    require.ensure([], () => r(require('../views/activityTemplateNew.vue')), 'activityTemplateNew');
const actTmp = r => require.ensure([], () => r(require('../views/actTmp.vue')), 'actTmp');
//  生美医美订单- 问卷判断页
const quesBefore = r => require.ensure([], () => r(require('../views/ques/quesBefore.vue')), 'quesBefore');
//  问卷预览页
const quesPreview = r => require.ensure([], () => r(require('../views/ques/quesPreview.vue')), 'quesPreview');
//  问卷答卷页
const quesOnline = r => require.ensure([], () => r(require('../views/ques/quesOnline.vue')), 'quesOnline');
//  问卷答卷详情页
const quesDetail = r => require.ensure([], () => r(require('../views/ques/quesDetail.vue')), 'quesDetail');
//  问卷答卷后签名页
const signature = r => require.ensure([], () => r(require('../views/ques/signature.vue')), 'signature');

// 公众号测试页
const gongzhonghao = r => require.ensure([], () => r(require('../views/glytest/gongzhonghao.vue')), 'gongzhonghao');
// 跳转小程序支付
const payjump = r => require.ensure([], () => r(require('../views/glytest/payjump.vue')), 'payjump');
// 网页工具
const web = r => require.ensure([], () => r(require('../views/activity/web.vue')), 'web');
//H5预约-登录
const rightsLogin = r => require.ensure([], () => r(require('../views/rightsAndBook/rightsLogin.vue')), 'rightsLogin');
//我的权益
const myRights = r => require.ensure([], () => r(require('../views/rightsAndBook/myRights.vue')), 'myRights');
//确认预约
const subscribe = r => require.ensure([], () => r(require('../views/rightsAndBook/subscribe.vue')), 'subscribe');
//兑换权益
const exRights = r => require.ensure([], () => r(require('../views/rightsAndBook/exRights.vue')), 'exRights');
//历史权益
const historicalRights = r =>
    require.ensure([], () => r(require('../views/rightsAndBook/historicalRights.vue')), 'historicalRights');
//我的预约
const myAppointment = r =>
    require.ensure([], () => r(require('../views/rightsAndBook/myAppointment.vue')), 'myAppointment');

/** h5商品下单 */
//商品列表
const productsList = r => require.ensure([], () => r(require('../views/storeModule/productsList.vue')), 'productsList');
//商品详情
const productDesc = r => require.ensure([], () => r(require('../views/storeModule/productDesc.vue')), 'productDesc');
//确认订单
const orderConfirm = r => require.ensure([], () => r(require('../views/storeModule/orderConfirm.vue')), 'orderConfirm');
//订单详情
const orderDetail = r => require.ensure([], () => r(require('../views/storeModule/orderDetail.vue')), 'orderDetail');
//预约列表
const subsList = r => require.ensure([], () => r(require('../views/storeModule/subsList.vue')), 'subsList');

//scanQrcode
const scanQrcode = r => require.ensure([], () => r(require('../views/scanQrcode.vue')), 'scanQrcode');
//配置普通活动H5链接
const actGroup = r => require.ensure([], () => r(require('../views/actGroup.vue')), 'actGroup');

// -------------------------新春活动-------------------------
// 转盘抽奖
const wheel = r => require.ensure([], () => r(require('../views/newYearGame/wheel.vue')), 'wheel');
//中奖记录
const winRecords = r => require.ensure([], () => r(require('../views/newYearGame/winRecords.vue')), 'winRecords');
//排行榜
const rankingList = r => require.ensure([], () => r(require('../views/newYearGame/rankingList.vue')), 'rankingList');
//活动规则
const actRules = r => require.ensure([], () => r(require('../views/newYearGame/actRules.vue')), 'actRules');
//微信客服测试
const wechat = r => require.ensure([], () => r(require('../views/glytest/wechat.vue')), 'wechat');

//员工助手聊天
const wechatChat = r => require.ensure([], () => r(require('../views/wechat/index.vue')), 'wechatChat');

const sale2024 = r => require.ensure([], () => r(require('../views/sale2024.vue')), 'sale2024');
//H5支付test
const payMoney = r => require.ensure([], () => r(require('../views/payMoney.vue')), 'payMoney');
//   联营H5商城

//  联营商城授权
const authorize = r => require.ensure([], () => r(require('../views/lianyingShop/authorize.vue')), 'authorize');
// 环境判断公共页面
const uaTest = r => require.ensure([], () => r(require('../views/uaTest.vue')), 'uaTest');
// 用户信息测试页面
const userInfo = r => require.ensure([], () => r(require('../views/lianyingShop/userInfo.vue')), 'userInfo');
const productsListLy = r =>
    require.ensure([], () => r(require('../views/lianyingShop/productsList.vue')), 'productsListLy');
//商品详情
const productDescLy = r =>
    require.ensure([], () => r(require('../views/lianyingShop/productDesc.vue')), 'productDescLy');
//确认订单
const orderConfirmLy = r =>
    require.ensure([], () => r(require('../views/lianyingShop/orderConfirm.vue')), 'orderConfirmLy');
//订单详情
const orderDetailLy = r =>
    require.ensure([], () => r(require('../views/lianyingShop/orderDetail.vue')), 'orderDetailLy');
// 订单列表
const orderListLy = r => require.ensure([], () => r(require('../views/lianyingShop/orderList.vue')), 'orderListLy');
const subsListLy = r => require.ensure([], () => r(require('../views/lianyingShop/subsList.vue')), 'subsListLy');
const lyLogin = r => require.ensure([], () => r(require('../views/lianyingShop/lyLogin.vue')), 'lyLogin');
const lyMy = r => require.ensure([], () => r(require('../views/lianyingShop/lyMy.vue')), 'lyMy');

// 秀可儿医美隐私政策
// 贝黎诗隐私相关页面 palaispa
const cellcarePolicy = r => require.ensure([], () => r(require('../views/cellcare/policy.vue')), 'cellcarePolicy');
const cellcareUserAgreement = r =>
    require.ensure([], () => r(require('../views/cellcare/userAgreement.vue')), 'cellcareUserAgreement');
const cellcareSummary = r => require.ensure([], () => r(require('../views/cellcare/summary.vue')), 'cellcareSummary');
const cellcarePersonalInfo = r =>
    require.ensure([], () => r(require('../views/cellcare/personalInfo.vue')), 'cellcarePersonalInfo');
const cellcareThirdPartyInfo = r =>
    require.ensure([], () => r(require('../views/cellcare/thirdPartyInfo.vue')), 'cellcareThirdPartyInfo');
const cellcareLogoutFile = r =>
    require.ensure([], () => r(require('../views/cellcare/logoutFile.vue')), 'cellcareLogoutFile');
// neology设置相关

const neologyPolicy = r => require.ensure([], () => r(require('../views/neology/policy.vue')), 'neologyPolicy');
const neologyUserAgreement = r =>
    require.ensure([], () => r(require('../views/neology/userAgreement.vue')), 'neologyUserAgreement');
const neologySummary = r => require.ensure([], () => r(require('../views/neology/summary.vue')), 'neologySummary');
const neologyPersonalInfo = r =>
    require.ensure([], () => r(require('../views/neology/personalInfo.vue')), 'neologyPersonalInfo');
const neologyThirdPartyInfo = r =>
    require.ensure([], () => r(require('../views/neology/thirdPartyInfo.vue')), 'neologyThirdPartyInfo');
const neologyLogoutFile = r =>
    require.ensure([], () => r(require('../views/neology/logoutFile.vue')), 'neologyLogoutFile');

//   新增固定参数跳转页面

const scheme1 = r => require.ensure([], () => r(require('../views/scheme1.vue')), 'scheme1');
const scheme2 = r => require.ensure([], () => r(require('../views/scheme2.vue')), 'scheme2');
const scheme3 = r => require.ensure([], () => r(require('../views/scheme3.vue')), 'scheme3');
//   新增短信链接跳转公共页面

const messagePublic = r => require.ensure([], () => r(require('../views/messageLink/publicUrl.vue')), 'publicUrl');
const msglink1 = r => require.ensure([], () => r(require('../views/messageLink/msglink1.vue')), 'msglink1');
const urlHR = r => require.ensure([], () => r(require('../views/messageLink/urlHR.vue')), 'urlHR');
const newCustomer = r => require.ensure([], () => r(require('../views/messageLink/newCustomer.vue')), 'newCustomer');
const productDetail = r =>
    require.ensure([], () => r(require('../views/messageLink/productDetail.vue')), 'productDetail');
const msgCommon = r => require.ensure([], () => r(require('../views/messageLink/common.vue')), 'msgCommon');
const msgCommonNaturade = r =>
    require.ensure([], () => r(require('../views/messageLink/commonNaturade.vue')), 'msgCommonNaturade');
const msgCommonSyl = r => require.ensure([], () => r(require('../views/messageLink/commonSyl.vue')), 'msgCommonSyl');

const report2025 = r => require.ensure([], () => r(require('../views/report/report2025.vue')), 'report2025');

// 评估跳转应用页面
const evalutionToApp = r => require.ensure([], () => r(require('../views/evalutionToApp.vue')), 'evalutionToApp');
// 评价详情页面
const evalutionDetail = r => require.ensure([], () => r(require('../views/evalutionDetail.vue')), 'evalutionDetail');
// 术后通知页面
const postoperativeNotice = r =>
    require.ensure([], () => r(require('../views/postoperativeNotice/index.vue')), 'postoperativeNotice');
// 门诊地址+注意事项
const mapAndNotice = r => require.ensure([], () => r(require('../views/mapAndNotice/index.vue')), 'mapAndNotice');

// ai问答
const aiFAQs = r => require.ensure([], () => r(require('../views/aiFAQs/index.vue')), 'aiFAQs');
const afterSaleExpert = r => require.ensure([], () => r(require('../views/aiFAQs/afterSaleExpert.vue')), 'afterSaleExpert');

// ========================== 奈瑞儿+ 微信小程序原生页面迁移 Start ==========================

// 招牌美养
const natvipWechatProductList = r =>
    require.ensure([], () => r(require('../views/natvipWechat/productList.vue')), 'natvipWechatProductList');

// 产品详情
const natvipWechatProductDetail = r =>
    require.ensure([], () => r(require('../views/natvipWechat/productDetail.vue')), 'natvipWechatProductDetail');
// ========================== 奈瑞儿+ 微信小程序原生页面迁移 End ==========================

// ========================== 周年履历 Start ==========================
const flipHome = r => require.ensure([], () => r(require('../views/flipHome/home.vue')), 'flipHome');
const flipLoading = r => require.ensure([], () => r(require('../views/flipHome/loading.vue')), 'flipLoading');
const flipResume = r => require.ensure([], () => r(require('../views/flipHome/resume.vue')), 'flipResume');
const flipAd = r => require.ensure([], () => r(require('../views/flipHome/ad.vue')), 'flipAd');
const flipLastPage = r => require.ensure([], () => r(require('../views/flipHome/lastPage.vue')), 'flipLastPage');
// ========================== 周年履历 End ==========================


// ========================== 思妍丽ipad画册 ==========================
const ipadService = r => require.ensure([], () => r(require('../views/ipadService/service.vue')), 'ipadService');
const ipadServiceDetail = r =>
    require.ensure([], () => r(require('../views/ipadService/serviceDetail.vue')), 'ipadServiceDetail');


// 启用路由
Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/disinfect',
            name: 'disinfect',
            component: disinfect,
            meta: {
                title: '消杀上传',
            },
        },
        {
            path: '/notelink',
            name: 'notelink',
            component: notelink,
            meta: {
                title: '跳转小程序',
            },
        },
        {
            path: '/coupons3000',
            name: 'coupons3000',
            component: coupons3000,
            meta: {
                title: '领取优惠券',
            },
        },
        {
            path: '/coupons4000',
            name: 'coupons4000',
            component: coupons4000,
            meta: {
                title: '领取优惠券',
            },
        },
        {
            path: '/probioticsClock',
            name: 'probioticsClock',
            component: probioticsClock,
            meta: {
                title: '益生菌打卡',
            },
        },
        {
            path: '/probioticsClockFst',
            name: 'probioticsClockFst',
            component: probioticsClockFst,
            meta: {
                title: '益生菌打卡',
            },
        },
        {
            path: '/probioticsClockSec',
            name: 'probioticsClockSec',
            component: probioticsClockSec,
            meta: {
                title: '益生菌打卡',
            },
        },
        {
            path: '/probioticsClockThr',
            name: 'probioticsClockThr',
            component: probioticsClockThr,
            meta: {
                title: '益生菌打卡',
            },
        },
        {
            path: '/probioticsClockFou',
            name: 'probioticsClockFou',
            component: probioticsClockFou,
            meta: {
                title: '益生菌打卡',
            },
        },
        {
            path: '/probioticsClockFif',
            name: 'probioticsClockFif',
            component: probioticsClockFif,
            meta: {
                title: '益生菌打卡',
            },
        },
        {
            path: '/probioticsClockSix',
            name: 'probioticsClockSix',
            component: probioticsClockSix,
            meta: {
                title: '益生菌打卡',
            },
        },
        {
            path: '/advert',
            name: 'advert',
            component: advert,
            meta: {
                title: '广告详情',
            },
        },
        {
            path: '/scheme',
            name: 'scheme',
            component: scheme,
            meta: {
                title: '短信跳转',
            },
        },
        {
            path: '/schemeToSub',
            name: 'schemeToSub',
            component: schemeToSub,
            meta: {
                title: '短信跳转',
            },
        },
        {
            path: '/schemeMine',
            name: 'schemeMine',
            component: schemeMine,
            meta: {
                title: '短信跳转',
            },
        },
        {
            path: '/forVvip',
            name: 'forVvip',
            component: forVvip,
            meta: {
                title: 'forVvip优化数据',
            },
        },
        {
            path: '/anniversary',
            name: 'anniversary',
            component: anniversary,
            meta: {
                title: '系列年卡限时赠送',
            },
        },
        {
            path: '/highValue',
            name: 'highValue',
            component: highValue,
            meta: {
                title: 'VIP女神最IN礼品领取',
            },
        },
        {
            path: '/wednesday',
            name: 'wednesday',
            component: wednesday,
            meta: {
                title: '周三三折活动',
            },
        },
        {
            path: '/policy',
            name: 'policy',
            component: policy,
            meta: {
                title: '隐私政策',
            },
        },
        {
            path: '/buyShow',
            name: 'buyShow',
            component: buyShow,
            meta: {
                title: '换购特权',
            },
        },
        {
            path: '/pageTo',
            name: 'pageTo',
            component: pageTo,
            meta: {
                title: '外部H5页面承接',
            },
        },
        {
            path: '/toLive',
            name: 'toLive',
            component: toLive,
            meta: {
                title: '直播跳转',
            },
        },
        {
            path: '/logoutFile',
            name: 'logoutFile',
            component: logoutFile,
            meta: {
                title: '美丽田园账号注销须知',
            },
        },
        {
            path: '/personalInfo',
            name: 'personalInfo',
            component: personalInfo,
            meta: {
                title: '个人信息收集清单',
            },
        },
        {
            path: '/thirdPartyInfo',
            name: 'thirdPartyInfo',
            component: thirdPartyInfo,
            meta: {
                title: '个人信息共享清单',
            },
        },
        {
            path: '/userAgreement',
            name: 'userAgreement',
            component: userAgreement,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/summary',
            name: 'summary',
            component: summary,
            meta: {
                title: '隐私政策摘要',
            },
        },
        {
            path: '/plsPolicy',
            name: 'palaispaPolicy',
            component: palaispaPolicy,
            meta: {
                title: '隐私政策',
            },
        },
        {
            path: '/cellcarePolicy',
            name: 'cellcarePolicy',
            component: cellcarePolicy,
            meta: {
                title: '隐私政策',
            },
        },
        {
            path: '/plsUserAgreement',
            name: 'palaispaUserAgreement',
            component: palaispaUserAgreement,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/cellcareUserAgreement',
            name: 'cellcareUserAgreement',
            component: cellcareUserAgreement,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/plsSummary',
            name: 'palaispaSummary',
            component: palaispaSummary,
            meta: {
                title: '隐私政策摘要',
            },
        },
        {
            path: '/cellcareSummary',
            name: 'cellcareSummary',
            component: cellcareSummary,
            meta: {
                title: '隐私政策摘要',
            },
        },
        {
            path: '/plsPersonalInfo',
            name: 'palaispaPersonalInfo',
            component: palaispaPersonalInfo,
            meta: {
                title: '个人信息收集清单',
            },
        },
        {
            path: '/cellcarePersonalInfo',
            name: 'cellcarePersonalInfo',
            component: cellcarePersonalInfo,
            meta: {
                title: '个人信息收集清单',
            },
        },
        {
            path: '/plsThirdPartyInfo',
            name: 'palaispaThirdPartyInfo',
            component: palaispaThirdPartyInfo,
            meta: {
                title: '个人信息共享清单',
            },
        },
        {
            path: '/cellcareThirdPartyInfo',
            name: 'cellcareThirdPartyInfo',
            component: cellcareThirdPartyInfo,
            meta: {
                title: '个人信息共享清单',
            },
        },
        {
            path: '/plsLogoutFile',
            name: 'palaispaLogoutFile',
            component: palaispaLogoutFile,
            meta: {
                title: '个人信息共享清单',
            },
        },
        {
            path: '/cellcareLogoutFile',
            name: 'cellcareLogoutFile',
            component: cellcareLogoutFile,
            meta: {
                title: '个人信息共享清单',
            },
        },
        {
            path: '/dataSearch',
            name: 'dataSearch',
            component: dataSearch,
            meta: {
                title: '数据查询',
            },
        },
        {
            path: '/christmasSales',
            name: 'christmasSales',
            component: christmasSales,
            meta: {
                title: '圣诞大促',
            },
        },
        {
            path: '/publicAct',
            name: 'publicAct',
            component: publicAct,
            meta: {
                title: '短信跳转专区页面',
            },
        },
        {
            path: '/goodsDetail',
            name: 'goodsDetail',
            component: goodsDetail,
            meta: {
                title: '短信跳转商品详情页面',
            },
        },
        {
            path: '/sphScheme',
            name: 'sphScheme',
            component: sphScheme,
            meta: {
                title: '短信跳转分享活动页面',
            },
        },
        {
            path: '/schemeLz',
            name: 'schemeLz',
            component: schemeLz,
            meta: {
                title: '留资页面跳转活动页面',
            },
        },
        {
            path: '/quesBefore',
            name: 'quesBefore',
            component: quesBefore,
            meta: {
                title: '问卷',
            },
        },
        {
            path: '/quesPreview',
            name: 'quesPreview',
            component: quesPreview,
            meta: {
                title: '问卷预览',
            },
        },
        {
            path: '/quesOnline',
            name: 'quesOnline',
            component: quesOnline,
            meta: {
                title: '问卷',
            },
        },
        {
            path: '/quesDetail',
            name: 'quesDetail',
            component: quesDetail,
            meta: {
                title: '答卷详情',
            },
        },
        {
            path: '/signature',
            name: 'signature',
            component: signature,
            meta: {
                title: '质控检查',
            },
        },
        {
            path: '/activityTemplate',
            name: 'activityTemplate',
            component: activityTemplate,
            meta: {
                title: '活动',
            },
        },
        {
            path: '/activityTemplateNew',
            name: 'activityTemplateNew',
            component: activityTemplateNew,
            meta: {
                title: '活动',
            },
        },
        {
            path: '/gongzhonghao',
            name: 'gongzhonghao',
            component: gongzhonghao,
            meta: {
                title: '公众号',
            },
        },
        {
            path: '/payjump',
            name: 'payjump',
            component: payjump,
            meta: {
                title: '跳转小程序支付',
            },
        },
        {
            path: '/web',
            name: 'web',
            component: web,
            meta: {
                title: '活动中心',
            },
        },
        {
            path: '/actTmp',
            name: 'actTmp',
            component: actTmp,
            meta: {
                title: '活动',
            },
        },
        {
            path: '/rightsLogin',
            name: 'rightsLogin',
            component: rightsLogin,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/myRights',
            name: 'myRights',
            component: myRights,
            meta: {
                title: '我的权益',
            },
        },
        {
            path: '/subscribe',
            name: 'subscribe',
            component: subscribe,
            meta: {
                title: '确认预约',
            },
        },
        {
            path: '/exRights',
            name: 'exRights',
            component: exRights,
            meta: {
                title: '兑换权益',
            },
        },
        {
            path: '/historicalRights',
            name: 'historicalRights',
            component: historicalRights,
            meta: {
                title: '历史权益',
            },
        },
        {
            path: '/myAppointment',
            name: 'myAppointment',
            component: myAppointment,
            meta: {
                title: '我的预约',
            },
        },
        /** h5商品下单 */
        {
            path: '/productsList',
            name: 'productsList',
            component: productsList,
            meta: {
                title: '商品列表',
            },
        },
        {
            path: '/productDesc',
            name: 'productDesc',
            component: productDesc,
            meta: {
                title: '商品详情',
            },
        },
        {
            path: '/orderConfirm',
            name: 'orderConfirm',
            component: orderConfirm,
            meta: {
                title: '确认订单',
            },
        },
        {
            path: '/orderDetail',
            name: 'orderDetail',
            component: orderDetail,
            meta: {
                title: '订单详情',
            },
        },
        {
            path: '/subsList',
            name: 'subsList',
            component: subsList,
            meta: {
                title: '预约列表',
            },
        },
        /**  识别二维码 */
        {
            path: '/scanQrcode',
            name: 'scanQrcode',
            component: scanQrcode,
            meta: {
                title: '识别二维码',
            },
        },
        /**  配置普通活动h5链接 */
        {
            path: '/actGroup',
            name: 'actGroup',
            component: actGroup,
            meta: {
                title: '活动模板页',
            },
        },
        /**  新春抽奖 */
        {
            path: '/wheel',
            name: 'wheel',
            component: wheel,
            meta: {
                title: '国庆美美搭',
            },
        },
        /**  中奖记录 */
        {
            path: '/winRecords',
            name: 'winRecords',
            component: winRecords,
            meta: {
                title: '中奖记录',
            },
        },
        /**  排行榜 */
        {
            path: '/rankingList',
            name: 'rankingList',
            component: rankingList,
            meta: {
                title: '排行榜',
            },
        },
        /**  活动规则 */
        {
            path: '/actRules',
            name: 'actRules',
            component: actRules,
            meta: {
                title: '活动规则',
            },
        },
        /**  微信客服测试 */
        {
            path: '/wechat',
            name: 'wechat',
            component: wechat,
            meta: {
                title: '微信客服测试',
            },
        },
        {
            path: '/sale2024',
            name: 'sale2024',
            component: sale2024,
            meta: {
                title: '2024开门红',
            },
        },
        /** 支付H5test */
        {
            path: '/payMoney',
            name: 'payMoney',
            component: payMoney,
            meta: {
                title: '支付test',
            },
        },
        {
            path: '/lianyingShop/authorize',
            name: 'authorize',
            component: authorize,
            meta: {
                title: '授权',
            },
        },
        {
            path: '/uaTest',
            name: 'uaTest',
            component: uaTest,
            meta: {
                title: '环境测试',
                authorize: true,
            },
        },
        {
            path: '/userInfo',
            name: 'userInfo',
            component: userInfo,
            meta: {
                title: '用户信息',
            },
        },
        {
            path: '/productsListLy',
            name: 'productsListLy',
            component: productsListLy,
            meta: {
                title: '商品列表',
                showTabbar: true,
                authorize: false,
            },
        },
        {
            path: '/productDescLy',
            name: 'productDescLy',
            component: productDescLy,
            meta: {
                title: '商品详情',
                authorize: false,
                isHomeIcon: true,
            },
        },
        {
            path: '/orderConfirmLy',
            name: 'orderConfirmLy',
            component: orderConfirmLy,
            meta: {
                title: '确认订单',
                authorize: true,
                isHomeIcon: true,
            },
        },
        {
            path: '/orderDetailLy',
            name: 'orderDetailLy',
            component: orderDetailLy,
            meta: {
                title: '订单详情',
                authorize: true,
                isHomeIcon: true,
            },
        },
        {
            path: '/orderListLy',
            name: 'orderListLy',
            component: orderListLy,
            meta: {
                title: '订单列表',
                authorize: true,
                isHomeIcon: true,
            },
        },
        {
            path: '/subsListLy',
            name: 'subsListLy',
            component: subsListLy,
            meta: {
                title: '门店',
                authorize: true,
            },
        },
        // 短信跳转页面
        {
            path: '/scheme1',
            name: 'scheme1',
            component: scheme1,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/scheme2',
            name: 'scheme2',
            component: scheme2,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/scheme3',
            name: 'scheme3',
            component: scheme3,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/messagePublic',
            name: 'messagePublic',
            component: messagePublic,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/msglink1',
            name: 'msglink1',
            component: msglink1,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/urlHR',
            name: 'urlHR',
            component: urlHR,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/lyLogin',
            name: 'lyLogin',
            component: lyLogin,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/lyMy',
            name: 'lyMy',
            component: lyMy,
            meta: {
                showTabbar: true,
                authorize: true,
                title: '美丽田园',
            },
        },
        {
            path: '/newCustomer',
            name: 'newCustomer',
            component: newCustomer,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/productDetail',
            name: 'productDetail',
            component: productDetail,
            meta: {
                title: '美丽田园',
            },
        },
        {
            path: '/msgCommon',
            name: 'msgCommon',
            component: msgCommon,
            meta: {},
        },
        {
            path: '/msgCommonNaturade',
            name: 'msgCommonNaturade',
            component: msgCommonNaturade,
            meta: {},
        },
        {
            path: '/msgCommonSyl',
            name: 'msgCommonSyl',
            component: msgCommonSyl,
            meta: {},
        },
        {
            path: '/w', // 以防万一做个备份，兼容奈瑞儿历史的短链接:s.nrezs.com/w/?u=4
            name: 'w',
            component: msgCommonNaturade,
            meta: {},
        },
        {
            path: '/report2025',
            name: 'report2025',
            component: report2025,
            meta: {
                title: '年度报告',
            },
        },
        {
            path: '/neologyPolicy',
            name: 'neologyPolicy',
            component: neologyPolicy,
            meta: {
                title: '隐私政策',
            },
        },
        {
            path: '/neologySummary',
            name: 'neologySummary',
            component: neologySummary,
            meta: {
                title: '隐私政策摘要',
            },
        },
        {
            path: '/neologyUserAgreement',
            name: 'neologyUserAgreement',
            component: neologyUserAgreement,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/neologyPersonalInfo',
            name: 'neologyPersonalInfo',
            component: neologyPersonalInfo,
            meta: {
                title: '个人信息收集清单',
            },
        },
        {
            path: '/neologyThirdPartyInfo',
            name: 'neologyThirdPartyInfo',
            component: neologyThirdPartyInfo,
            meta: {
                title: '个人信息共享清单',
            },
        },
        {
            path: '/neologyLogoutFile',
            name: 'neologyLogoutFile',
            component: neologyLogoutFile,
            meta: {
                title: '账号注销',
            },
        },
        {
            path: '/evalutionToApp',
            name: 'evalutionToApp',
            component: evalutionToApp,
            meta: {
                title: '评价',
            },
        },
        {
            path: '/evalutionDetail',
            name: 'evalutionDetail',
            component: evalutionDetail,
            meta: {
                title: '评价',
            },
        },
        {
            path: '/postoperativeNotice',
            name: 'postoperativeNotice',
            component: postoperativeNotice,
            meta: {
                title: '术后通知',
            },
        },
        {
            path: '/mapAndNotice',
            name: 'mapAndNotice',
            component: mapAndNotice,
            meta: {
                title: '门诊地址+注意事项',
            },
        },
        {
            path: '/aiFAQs',
            name: 'aiFAQs',
            component: aiFAQs,
            meta: {
                title: 'AI问答',
            },
        },
        {
            path: '/afterSaleExpert',
            name: 'afterSaleExpert',
            component: afterSaleExpert,
            meta: {
                title: '售后专家',
            },
        },
        {
            path: '/wechat-chat',
            name: 'wechatChat',
            component: wechatChat,
            meta: {
                title: '员工助手',
            },
        },
        {
            path: '/natvipWechatProductList',
            name: 'natvipWechatProductList',
            component: natvipWechatProductList,
            meta: {
                title: '招牌美养',
            },
        },
        {
            path: '/natvipWechatProductDetail',
            name: 'natvipWechatProductDetail',
            component: natvipWechatProductDetail,
            meta: {
                title: '详情',
            },
        },
        // ========================== 周年履历 ==========================
        {
            path: '/flipHome',
            name: 'flipHome',
            component: flipHome,
            meta: {
                title: '33周年时光回信',
            },
        },
        {
            path: '/flipLoading',
            name: 'flipLoading',
            component: flipLoading,
            meta: {
                title: '生成中',
            },
        },
        {
            path: '/flipResume',
            name: 'flipResume',
            component: flipResume,
            meta: {
                title: '发光履历',
            },
        },
        {
            path: '/flipAd',
            name: 'flipAd',
            component: flipAd,
            meta: {
                title: '重磅新品上市',
            },
        },
        {
            path: '/flipLastPage',
            name: 'flipLastPage',
            component: flipLastPage,
            meta: {
                title: '美丽启程',
            },
        },
        {
            path: '/ipadService',
            name: 'ipadService',
            component: ipadService,
            meta: {
                title: '思妍丽ipad画册',
            },
        },
        {
            path: '/ipadServiceDetail',
            name: 'ipadServiceDetail',
            component: ipadServiceDetail,
            meta: {
                title: '项目详情',
            },
        },
    ]
        .concat(talentRoutes)
        .concat(natvipRoutes)
        .concat(childOneRoutes),
});
var timeOut;
router.beforeEach((to, from, next) => {
    const baseURL = getBaseUrl(to.query && to.query.brandName);

    axios.defaults.baseURL = baseURL;

    // 对“强制重新加载”的页面（如 natvipHistory 系列）：
    // 1) 先清空 flexible 的 override 栈，避免 keep-alive 页面残留的 rem 规则影响新路由
    if (to?.meta?.forceReload && typeof window !== 'undefined') {
        if (typeof window.flexibleOverrideClearAll === 'function') {
            window.flexibleOverrideClearAll();
        }
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (timeOut) {
        clearTimeout(timeOut);
    }
    //  路由加授权标识，标识这些页面走授权
    if (to.query.openid) {
        window.sessionStorage.openid = to.query.openid;
    }
    if (to.query.curopenid) {
        window.sessionStorage.curopenid = to.query.curopenid;
    }
    if (to.query.preopenid) {
        window.sessionStorage.preopenid = to.query.preopenid;
    }
    // return
    if (to.meta.authorize) {
        if (!window.sessionStorage.openid) {
            // window.location.href = `${AUTH_URL}?appid=${AUTH_APPID}&target=http://10.100.84.135:8081${to.fullPath}&scope=snsapi_userinfo`
            window.location.href = `${AUTH_URL}?appid=${AUTH_APPID}&target=${VISIT_URL}${to.fullPath}?scope=snsapi_userinfo`;
        } else {
            // 已经授权没有获取用户信息
            if (!window.sessionStorage.customerInfo) {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0,
                });
                axios
                    .post(
                        `${GET_USERINFO_By_OPENID_URL}`,
                        { openId: window.sessionStorage.openid },
                        { headers: { 'Content-Type': 'application/json; charset=UTF-8' } },
                    )
                    .then(res => {
                        Toast.clear();
                        if (res.code == 0) {
                            if (res.data.customerInfo) {
                                window.sessionStorage.customerInfo = res.data.customerInfo && JSON.stringify(res.data.customerInfo);
                            }
                            if (res.data.token) {
                                window.sessionStorage.tokenInfo = res.data.token && JSON.stringify(res.data.token);
                            }
                            if (!res.data.customerInfo.phone) {
                                next({ path: '/lyLogin', query: { fullPath: to.fullPath } });
                            } else {
                                next();
                            }
                        } else {
                            Toast({ message: res.msg, duration: 3000 });
                        }
                    });
            } else if (!(window.sessionStorage.customerInfo && JSON.parse(window.sessionStorage.customerInfo).phone)) {
                next({ path: '/lyLogin', query: { fullPath: to.fullPath } });
            } else {
                next();
            }
        }
    } else {
        next();
    }
});

// 路由切换后刷新 rem（history pushState 不会触发 popstate，需手动通知 flexible.js）
router.afterEach(() => {
    // 统一在 remManager 里处理：路由级策略 + override token 管理 + refresh
    applyRemPolicyForRoute(router?.currentRoute);
});
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js